var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppWithLoading',{attrs:{"fetch":_vm.fetchHandler},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var localLoading = ref.localLoading;
var loader = ref.loader;
return [(!_vm.requireFailedRenewal || _vm.hasFailedRenewal)?_c('div',[(!localLoading)?[_vm._t("default",null,null,{
          prolongSubscriptionPayment: _vm.prolongSubscriptionPayment,
          loader: loader,
          hasActivePaymentMethod: _vm.hasActivePaymentMethod,
          error: _vm.error,
          hasFailedRenewal: _vm.hasFailedRenewal,
          errorStripe: _vm.errorStripe
        })]:_vm._e()],2):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }